var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad-container",class:'myticketi' ? 'd-none':''},[(_vm.project == 'ticketak')?_c('img',{staticClass:"img-fluid",attrs:{"src":require("@/assets/img/app_logo_single.png")}}):_c('img',{staticClass:"img-fluid",attrs:{"src":require("@/assets/img/102-x-150.jpg")}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-086a9f4a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/advertise.vue
// module id = 871
// module chunks = 32